<template>
  <span :id="model?.system?.id">
    <SmartLinkItemComponent :id="model?.system?.id" class="client-list" :component="!model?.system?.workflow">
      <div class="container client-list">
        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
          <h2 class="client-list__title">{{ data.title }}</h2>
        </SmartLinkStandaloneElement>
        <SmartLinkStandaloneElement :codename="type.elements.clients.codename">
          <div v-for="(row, index) in chunk(data.clients, 2)" :key="`client-group-${index}`" class="row">
            <div v-for="(client, i) in row.filter((r) => r.elements.clientName.value.length > 0)" :key="`client-${i}`"
              class="col-lg-6 client-list__wrapper">
              <div class="client-list__wrapper__item">
                <p>{{ client.elements.clientName.value }}</p>
              </div>
              <span class="client-list__wrapper__border" />
            </div>
          </div>
        </SmartLinkStandaloneElement>
      </div>
    </SmartLinkItemComponent>
  </span>
</template>
<script setup lang="ts">
import { type ClientModel, type ClientListModel } from '~/models'
import chunk from 'lodash/chunk'
import { contentTypes } from '~/models'
const type = contentTypes.client_list

const pageStore = usePageStore()
const siteStore = useSiteStore()
const props = defineProps<{ model: ClientListModel }>()

const data = {
  title: props.model?.elements.title.value,
  clients:
    pageStore.getListAs<ClientModel>(props.model?.elements.clients.value) ??
    siteStore.getListAs<ClientModel>(props.model?.elements.clients.value),
  toc: props.model?.elements.tableOfContentLinksTableOfContents.value
}
</script>
